import { useState, useEffect } from 'react';
import { FaEnvelope, FaGithub, FaLinkedin } from 'react-icons/fa';
import { useContactController } from '../controllers/ContactController';
import SectionWrapper from '../views/components/SectionWrapper';
import { useLanguage } from '../i18n/LanguageContext';

export default function ContactView() {
  const { t } = useLanguage();
  const { submit, submitting, status, error } = useContactController();
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  useEffect(() => {
    if (status === 'SENT') setForm({ name: '', email: '', message: '' });
  }, [status]);

  const handleChange = event =>
    setForm(currentForm => ({
      ...currentForm,
      [event.target.name]: event.target.value,
    }));

  const handleSubmit = event => {
    event.preventDefault();
    submit(form);
  };

  return (
    <SectionWrapper id="contact">
      <div className="contact-card row gx-0">
        <div className="col-md-6 contact-info p-4" data-aos="fade-right">
          <h3>{t('contact.connectTitle')}</h3>
          <p>{t('contact.intro')}</p>
          <ul className="info-list list-unstyled mt-4">
            <li>
              <FaGithub className="icon" />
              <a href="https://github.com/ZeeshanAhmedDev" target="_blank" rel="noopener noreferrer">
                {t('contact.github')}
              </a>
            </li>
            <li>
              <FaEnvelope className="icon" />
              <a href="mailto:contact@zeeshaanahmed.qzz.io">
                contact@zeeshaanahmed.qzz.io
              </a>
            </li>

            <li>
              <FaLinkedin className="icon" />
              <a href="https://www.linkedin.com/in/zeeshaanahmed/" target="_blank" rel="noopener noreferrer">
                {t('contact.linkedin')}
              </a>
            </li>
          </ul>
        </div>

        <div className="col-md-6 contact-form p-4" data-aos="fade-left">
          <h3>{t('contact.formTitle')}</h3>
          {status === 'SENT' ? (
            <div className="alert alert-success">{t('contact.success')}</div>
          ) : (
            <form onSubmit={handleSubmit} aria-label={t('contact.formAria')}>
              {error && (
                <div className="alert alert-danger">{error.message}</div>
              )}

              <div className="mb-3">
                <label className="form-label" htmlFor="name">
                  {t('contact.name')}
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  className="form-control"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label" htmlFor="email">
                  {t('contact.email')}
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className="form-control"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label" htmlFor="message">
                  {t('contact.message')}
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  className="form-control"
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-accent w-100"
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    {t('contact.sending')}
                  </>
                ) : (
                  t('contact.send')
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </SectionWrapper>
  );
}
